export default __webpack_public_path__ + "static/media/3.blur.89a42abd.jpg";